(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AlterarResponsavelTarefaController', AlterarResponsavelTarefaController);

    AlterarResponsavelTarefaController.$inject = ['$uibModalInstance', 'solicitacaoDesenvolvimento', 'SolicitacaoDesenvolvimento', 'User'];

    function AlterarResponsavelTarefaController($uibModalInstance, solicitacaoDesenvolvimento, SolicitacaoDesenvolvimento, User) {
        var vm = this;

        vm.solicitacaoDesenvolvimento = solicitacaoDesenvolvimento;
        vm.responsavelSelecionado = solicitacaoDesenvolvimento.responsavel || null;
        vm.isSaving = false;
        vm.save = save;
        vm.clear = clear;

        User.getAllInternos({}, function (data) {
            vm.users = data;
        });

        function save() {
            vm.isSaving = true;
            var payload = angular.copy(vm.solicitacaoDesenvolvimento);
            payload.responsavel = vm.responsavelSelecionado ? {id: vm.responsavelSelecionado.id} : null;

            SolicitacaoDesenvolvimento.trocarResponsavel(payload, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
